// pages/Dashboard.tsx
import React, { act, useEffect, useState } from "react";
import { clearCache, getCache } from "../util/Cache";
import { useNavigate } from "react-router-dom"
import { Menu, X, Home, Users, Clock, Star } from 'lucide-react';
import DashboardMain from "./dashboard/Main";
import DashboardDataKaryawan from "./dashboard/DataKaryawan";
import DashboardAbsensi from "./dashboard/Absensi";
import DashboardDataSKP from "./dashboard/Skp";
import DashboardDataHukdisTubel from "./dashboard/Hukdistubel";
import DashboardRekapAbsensi from "./dashboard/RekapAbsensi";
import logo from '../assets/image/logo512.png';
import DashboardRekapPengurangan from "./dashboard/RekapPengurangan";
import DashboardRekapStatus from "./dashboard/RekapStatus";

type sideBarType = { key: string; name: string; icon: React.JSX.Element; element: React.ComponentType<any>; level?: string[]; }[];
export type Theme = 'light' | 'dark';

export default function Dashboard({ SideBar, theme = 'light' }: { SideBar: sideBarType; theme?: Theme }) {
    const navigate = useNavigate();
    const [activeMenu, setActiveMenu] = useState<any>({});
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [userLevel, setUserLevel] = useState("");
    const isDark = theme === 'dark';

    const s = {
        bg: isDark ? 'bg-[#0d1117]' : 'bg-[#f6f8fa]',
        bgGradient: isDark ? 'bg-gradient-to-br from-[#0d1117] to-[#161b22]' : 'bg-gradient-to-br from-gray-50 to-blue-50',
        text: isDark ? 'text-[#e6edf3]' : 'text-[#1f2328]',
        textSecondary: isDark ? 'text-[#7d8590]' : 'text-gray-600',
        border: isDark ? 'border-[#21262d]' : 'border-[#d0d7de]',
        sidebar: isDark ? 'bg-[#161b22]' : 'bg-white',
        sidebarHover: isDark ? 'hover:bg-[#21262d]' : 'hover:bg-gray-100',
        active: isDark ? 'bg-[#0d4a66] text-[#00d4aa]' : 'bg-blue-50 text-blue-600',
        inactive: isDark ? 'text-[#7d8590]' : 'text-gray-700',
        button: { backgroundColor: '#ff0000', color: 'white', border: 'none', borderRadius: '8px', padding: '12px 16px', fontSize: '1.1rem', fontWeight: 'bold', cursor: 'pointer', textDecoration: 'none', transition: 'background-color 0.3s ease', marginTop: '20px' },
        title : isDark ? 'from-orange-600 to-yellow-300' : 'from-yellow-600 to-orange-600',
    };

    const checkUserDashboard = async () => {
        try {
            const data = await getCache("current_user");
            if (!data || !data.nama) {
                navigate("/login");
                return;
            }
            setUserLevel(data.level);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        setActiveMenu(filteredSidebar.length > 0 ? filteredSidebar[0] : "");
    }, []);

    const listSidebar: sideBarType = [
        { key : "dashboard",    name: "Dashboard", icon: <Home className="w-5 h-5 mr-3" />, element: DashboardMain },
        { key : "datakaryawan", name: "Data Karyawan", icon: <Users className="w-5 h-5 mr-3" />, element: DashboardDataKaryawan },
        { key : "dataabsensi",  name: "Data Absensi",  icon: <Clock className="w-5 h-5 mr-3" />, element: DashboardAbsensi },
        { key : "dataskp",  name: "Penilaian SKP",  icon: <Star className="w-5 h-5 mr-3" />, element: DashboardDataSKP },
        { key : "datahukdistubel",  name: "Hukdis & Tubel",  icon: <Star className="w-5 h-5 mr-3" />, element: DashboardDataHukdisTubel },
        { key : "datarekapabsensi",  name: "Rekap Absensi",  icon: <Star className="w-5 h-5 mr-3" />, element: DashboardRekapAbsensi },
        { key : "datarekappengurangan",  name: "Rekap Pengurangan",  icon: <Star className="w-5 h-5 mr-3" />, element: DashboardRekapPengurangan },
        { key : "datarekapstatus",  name: "Rekap Status",  icon: <Star className="w-5 h-5 mr-3" />, element: DashboardRekapStatus },
        { key : "datarekapuangmakan",  name: "Rekap Uang Makan",  icon: <Star className="w-5 h-5 mr-3" />, element: React.lazy(() => import("./dashboard/RekapUangMakan")) },
    ];

    const filteredSidebar = (() => {
        const dataSideBar = SideBar.length > 0 ? SideBar : listSidebar;
        const hasMatchingLevel = dataSideBar.some((item: any) => item.level?.includes(userLevel));
        return hasMatchingLevel ? dataSideBar.filter((item: any) => item.level && item.level.includes(userLevel)) : dataSideBar;
    })();

    return(
        <div className={`flex min-h-screen ${s.bgGradient}`}>
            {
                sidebarOpen && (
                    <div className={`fixed inset-y-0 left-0 z-50 w-64 md:relative md:inset-auto ${s.sidebar} shadow-2xl md:shadow-none transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 transition-transform duration-300 ease-in-out border-r ${s.border}`}>
                        <div className={`flex items-center justify-between p-5 border-b ${s.border}`}>
                            {/* <h1 className={`text-2xl font-bold bg-gradient-to-r ${s.title} bg-clip-text text-transparent`}>
                                Bawaslu
                            </h1> */}
                            <img src={logo} alt="Logo" className="h-14 w-auto object-contain center" />
                            <button
                                onClick={() => setSidebarOpen(false)}
                                className={`md:hidden p-2 rounded-lg ${s.sidebarHover}`}
                            >
                                <X className="w-5 h-5" />
                            </button>
                        </div>
                        
                        <nav className="mt-8">
                            <div className="px-6">
                                <div className="space-y-2">
                                    {filteredSidebar.map((item, index) => {
                                        const isActive = item.key === activeMenu.key;
                                        return (
                                            <div
                                                key={index}
                                                onClick={() => setActiveMenu(item)}
                                                className={`flex items-center px-4 py-3 rounded-lg transition-colors ${isActive ? s.active : `${s.inactive} ${s.sidebarHover}`} cursor-pointer`}
                                            >
                                                {item.icon}
                                                {item.name}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </nav>
                    </div>
                )
            }

            {/* Main Content */}
            <div className="flex-1 flex flex-col min-w-0">
                {/* Header with Menu Toggle */}
                <header className={`${s.sidebar} border-b ${s.border} px-6 py-4 flex items-center gap-4`}>
                    <button
                        onClick={() => setSidebarOpen(!sidebarOpen)}
                        className={`p-2 rounded-lg ${s.sidebarHover} transition-colors`}
                    >
                        
                        
                        <Menu className="w-6 h-6" />
                    </button>
                    <h2 className={`text-lg font-semibold ${s.text}`}>
                        {activeMenu.name || 'Dashboard'}
                    </h2>
                </header>

                {/* Dashboard Content */}
                <main className={`flex-1 min-w-0 p-6 ${s.text} overflow-y-auto overflow-x-hidden`}>
                    {
                        activeMenu.element ? (
                            <activeMenu.element theme={theme} />
                        ) : (
                            <div className="text-center py-20">
                                <h1 className={`text-3xl font-bold ${s.text}`}>Select a menu from the sidebar</h1>
                                <p className={`${s.textSecondary} mt-4`}>Please choose an option to view the dashboard content.</p>
                            </div>
                        )
                    }
                </main>
            </div>

            {/* Overlay for mobile */}
            {sidebarOpen && (
                <div 
                className="fixed inset-0 z-40 bg-black bg-opacity-50 md:hidden"
                onClick={() => setSidebarOpen(false)}
                />
            )}
        </div>
    );
}
